import { Navigate } from 'react-router-dom';

/**
 * Componente de proteção de rotas
 * Valida se o usuário está autenticado e tem o tipo de acesso correto
 *
 * IMPORTANTE: Esta é apenas uma camada de proteção no frontend.
 * A proteção real DEVE estar implementada no backend via verificarToken.
 *
 * @param {React.ReactNode} children - Componente a ser renderizado se autorizado
 * @param {string|string[]} requiredType - Tipo(s) de usuário permitido(s) ("administrador", "garcom", "master")
 * @param {string|string[]} [requiredFuncao] - Função(ões) de equipe permitida(s) dentro de "garcom"
 *   (ex.: "entregador") — checa a chave "funcao_equipe" do localStorage, gravada em Login.jsx a
 *   partir do tipo_usuario retornado pelo backend pra contas de Equipe.
 */
export function ProtectedRoute({ children, requiredType, requiredFuncao }) {
  const token = localStorage.getItem("token");
  const tipoUsuario = localStorage.getItem("tipo_usuario");
  const funcaoEquipe = localStorage.getItem("funcao_equipe");

  // Se não tem token, redireciona para a home
  if (!token) {
    console.warn('[ProtectedRoute] Token não encontrado, redirecionando para /home');
    return <Navigate to="/home" replace />;
  }

  // Se requiredType foi especificado, validar o tipo de usuário
  if (requiredType) {
    // Permite passar um array de tipos permitidos ou um único tipo
    const allowedTypes = Array.isArray(requiredType) ? requiredType : [requiredType];

    if (!allowedTypes.includes(tipoUsuario)) {
      console.warn(`[ProtectedRoute] Acesso negado. Tipo de usuário "${tipoUsuario}" não está em [${allowedTypes.join(', ')}]`);
      return <Navigate to="/" replace />;
    }
  }

  // Se requiredFuncao foi especificado, validar a função dentro da equipe
  if (requiredFuncao) {
    const allowedFuncoes = Array.isArray(requiredFuncao) ? requiredFuncao : [requiredFuncao];

    if (!allowedFuncoes.includes(funcaoEquipe)) {
      console.warn(`[ProtectedRoute] Acesso negado. Função "${funcaoEquipe}" não está em [${allowedFuncoes.join(', ')}]`);
      return <Navigate to="/" replace />;
    }
  }

  // Se passou nas validações, renderiza o componente
  return children;
}
